import { COLORS } from '../utils/colors';
import { siteContent } from '../content';

export const RockmelonLogo = ({ size = 56 }) => (
  <img
    src={siteContent.company.logo}
    alt={`${siteContent.company.name} logo`}
    width={size}
    height={size}
    className="drop-shadow-md"
    style={{ objectFit: 'contain' }}
  />
);

export const LogoWithText = () => (
  <div className="flex items-center space-x-3">
    <RockmelonLogo size={44} />
    <div className="flex flex-col">
      <span className="text-2xl font-bold tracking-tight" style={{ color: COLORS.navy, fontFamily: 'Montserrat, sans-serif' }}>
        {siteContent.company.name}
        <span style={{ color: COLORS.cantaloupe }}>.io</span>
      </span>
      <span className="text-xs tracking-wider" style={{ color: COLORS.slate }}>
        Executive IT Strategy
      </span>
    </div>
  </div>
);
